import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { TextInput } from '@topconagriculture/react-components';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useDashboardAPI } from '../../../hooks';
export default function PlaceAutocomplete({ value, onChange: setValue }) {
    const api = useDashboardAPI();
    const [inputValue, setInputValue] = React.useState(value.address);
    const { data: locations, isFetching } = useQuery({
        queryKey: ['getLocationByAddress', inputValue],
        queryFn: ({ queryKey: [key, address] }) => api.geocoding.getLocationByAddress(address),
    });
    return (React.createElement(Autocomplete, { getOptionLabel: (option) => option.address || '', options: locations || [], autoComplete: true, disableClearable: true, filterSelectedOptions: true, clearOnEscape: true, handleHomeEndKeys: true, closeIcon: null, loading: isFetching, value: value, onChange: (event, newValue) => {
            setValue(newValue);
        }, onInputChange: (event, newInputValue) => {
            setInputValue(newInputValue);
        }, renderInput: (params) => React.createElement(TextInput, { ...params, fullWidth: true }) }));
}
//# sourceMappingURL=PlaceAutocomplete.js.map